import React, { Component } from 'react'
import i18n from 'i18next'

class NPS extends Component {
    constructor(props) {
        super(props)
        const { question, store } = this.props
        const { form_data: formData } = store
        const set = question.optionSet
        const { options } = set
        const npsOptions = options.map(option => ({
            checked: formData.has(question.id) && formData.get(question.id).data.get('value') === option.id ? true : false,
            id: question.id,
        }))
        this.state = {
            npsOptions,
        }
    }

    handleClick = (option, idx, e) => {
        const copyOfState = { ...this.state }
        copyOfState.npsOptions.forEach((npsOption) => {
            const npsOptionRef = npsOption
            npsOptionRef.checked = false
        })
        copyOfState.npsOptions[idx].checked = !this.state.npsOptions[idx].checked
        this.setState(copyOfState)

        const { question, store } = this.props
        const { value } = e.currentTarget.dataset
        store.addFormResponse(question, value, option)
    }

    buildListItems = () => {
        const { question, store } = this.props
        const set = question.optionSet
        const { options } = set

        return options.map((option, idx) => {
            if (option.isHidden) {
                return null
            }
            return (
                <div
                    checked={option.checked}
                    key={option.id}
                >
                    <div className="circle">
                        <div
                            data-value={option.id}
                            onClick={this.handleClick.bind(this, option, idx)}
                            className={`circle__inner ${(this.state.npsOptions[idx].checked) ? 'circle_inner--selected' : ''}`}
                        >
                            {idx}
                        </div>
                    </div>
                </div>
            )
        })
    }

    render() {
        const listItems = this.buildListItems()
        return (
            <div className="nps">
                <div className="nps__instructions">
                    <span>
                        <i className="far fa-thumbs-down"></i>
                        <span>
                            {i18n.t('questions.nps.labels.notLikely')}
                        </span>
                    </span>
                    <span>
                        <span>
                            {i18n.t('questions.nps.labels.likely')}
                        </span>
                        <i className="far fa-thumbs-up"></i>
                    </span>
                </div>
                <div className="nps__options">
                    {listItems}
                </div>
            </div>
        )
    }
}

export default NPS
